





















































import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconWakaba from "@/common/components/icons/IconWakaba.vue";
import IconFaqBalloon from "@/common/components/icons/IconFaqBalloon.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "TheHeaderNaviOfOtherMenu",
  components: {
    NaviItemLinkForSpOnGeneral,
    IconBase,
    IconWakaba,
    IconFaqBalloon,
    IconMail
  }
})
export default class TheHeaderNaviOfOtherMenu extends Vue {
  @Prop({ type: String, required: true }) iconColor!: string;

  get urlNotification() {
    return process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html";
  }

  get urlFAQ() {
    return process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/";
  }
}
